import React, { useEffect, useState, useCallback } from 'react';
import { AssistantMessageProps } from '@copilotkit/react-ui';
import { Markdown } from '@copilotkit/react-ui';
import { convertMarkdownToHtml } from 'src/utils';
import { motion } from 'framer-motion';

export const AssistantMessage = (props: AssistantMessageProps) => {
  const { message } = props;

  // Extract content from message object or use message directly if it's a string
  const content = typeof message === 'string' ? message : message?.content || '';

  const [index, setIndex] = useState(0);
  const [finished, setFinished] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState<boolean>(true);

  const setRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      const isLast = !node.parentElement?.nextElementSibling;
      if (!isLast) {
        setShouldAnimate(false);
        setIndex(content.length);
        setFinished(true);
      }
    }
  }, [content.length]);

  useEffect(() => {
    if (!content || !shouldAnimate) return;

    if (index < content.length) {
      const timeout = setTimeout(() => {
        setIndex((prev) => prev + 1);
      }, Math.random() * 1 + 2);
      return () => clearTimeout(timeout);
    } else {
      setFinished(true);
    }
  }, [index, content, shouldAnimate]);

  const currentContent = content.slice(0, index);

  return (
    <motion.div
      className="flex flex-col assistant-message"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-start" ref={setRef}>
        <div className="text-text rounded-xl first-message whitespace-pre-wrap">
          {/* <Markdown content={finished ? message : currentContent + '|'} /> */}
          <div
            className="copilotKitMarkdownElement"
            dangerouslySetInnerHTML={{ __html: convertMarkdownToHtml(currentContent) }}
          />
        </div>
      </div>
    </motion.div>
  );
};
